module.exports = __webpack_public_path__ + "img/立邦.2f77d820.png";